import React, { useState, useContext } from "react";

import Header from "../shared/header";

import { SnackbarOrigin, Snackbar } from "@mui/material";

import MuiAlert from "@mui/material/Alert";

// import { Input, TextField, Button } from '@mui/material';

import { AccountContext } from "./Account";
import Pool from "./../../components/UserPool";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
  Navigate,
  json,
} from "react-router-dom";

import "./login.scss";

import "react-toastify/dist/ReactToastify.css";

import axios from "axios";

import { configure } from "../../config";

const config = {
  headers: {
    "Access-Control-Allow-Origin": "*",
    'Content-Type': 'application/json',
    "Access-Control-Allow-Methods": "*"
  },
};
var idToken = JSON.parse(sessionStorage.getItem("accessToken"));
const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isEmail, setIsEmail] = useState(false);
  const [isPassword, setIsPassword] = useState(false);
  const [product, setProduct] = useState("");
  var storedValue = sessionStorage.getItem("clickedInstrument");
  console.log(storedValue);

  var typeData = JSON.stringify({
    type: "ViewAll",

    fromDate: "",

    toDate: "",

    description: "",

    species: "",

    sampleName: "",

    status: "",

    instrument: storedValue,
  });

  const { authenticate, forgotPassword } = useContext(AccountContext);

  const [stateMsg, setStateMsg] = React.useState({
    open: false,

    vertical: "top",

    horizontal: "center",
  });

  const { vertical, horizontal, open } = stateMsg;

  const [msg, setMsg] = useState("");

  const [severity, setSeverity] = useState("");

  let navigate = useNavigate();

  // const   systemID="SCDM_Admin";

  // const   password="#S%9L76";

  // const   userId="nivedha.e@mphasis.com";

  // const [privileges, setPrivileges] = useState(["PRV-SCDM-ddSeq","PRV-SCDM-Genesis","PRV-SCDM-Sequoia"]);

  const onForgot = () => {
    // if (email.trim().length === 0) {
    //   return;
    // }
    if (email.trim().length === 0) {
      // Display an error message or handle it accordingly
      setMsg("Please enter your email.");
      setSeverity("error");
      setStateMsg({ open: true, vertical: "top", horizontal: "center" });
      return;
    }
    forgotPassword(email, null, null)
      .then((data) => {
        navigate("/forgotpassword");
      })

      .catch((err) => {
        console.log(err);
      });
  };

  const messageBox = (severity, msg) => {
    setSeverity(severity);

    setMsg(msg);

    var newState = {
      vertical: "top",

      horizontal: "center",
    };

    setStateMsg({ open: true, ...newState });
  };
  const handleAccessCheck = async () => {
    const usercheck = JSON.stringify({
      email: email,
    });
    var token = JSON.parse(sessionStorage.getItem("accessToken"));
    config.headers.Authorization = "Bearer " + token.jwtToken;
    const response = await fetch(`${configure.backendUrl}/listusers`, {
      method: 'POST',
      body: usercheck,
      headers: new Headers({ 'Authorization': 'Bearer ' + token.jwtToken })
    });
    const responseData = await response.json();
    if (responseData && response.status === 200) {
      const accessData = responseData[0];
      const adminAccessValue = accessData["custom:Admin_Access"];
      const ddseqAccessValue = accessData["custom:ddSEQ"];
      const genesisAccessValue = accessData["custom:Genesis"];
      const sequoiaAccessValue = accessData["custom:Sequoia"];
      sessionStorage.setItem("adminAccessValue", adminAccessValue);
      sessionStorage.setItem("ddseqAccessValue", ddseqAccessValue);
      sessionStorage.setItem("genesisAccessValue", genesisAccessValue);
      sessionStorage.setItem("sequoiaAccessValue", sequoiaAccessValue);
      navigate("/products");
    }
    else {
        const user = Pool.getCurrentUser();
        if (!user) {
          navigate("/login");
        }
    }


    // axios.post(
    //      "https://q340zrn3dk.execute-api.us-west-2.amazonaws.com/listusers", 
    //     usercheck,
    //     config
    //   )

    //   .then((response) => {
    //     // Handle the response from the API

    //     const accessData = response.data[0];

    //     console.log(">>>>>>>>>>>", accessData);

    //     //    const adminAccessValue=accessData['custom:Admin_Access'];

    //     //    const ddseqAccessValue=accessData['custom:ddSEQ'];

    //     //    const genesisAccessValue=accessData['custom:Genesis'];

    //     //    const sequoiaAccessValue=accessData['custom:Sequoia'];

    //     // const adminAccessValue = sessionStorage.getItem("adminAccessValue") === "true";

    //     // const ddseqAccessValue = sessionStorage.getItem("ddseqAccessValue") === "true";

    //     // const genesisAccessValue = sessionStorage.getItem("genesisAccessValue") === "true";

    //     // const sequoiaAccessValue = sessionStorage.getItem("sequoiaAccessValue") === "true";

    //     const adminAccessValue = accessData["custom:Admin_Access"];

    //     const ddseqAccessValue = accessData["custom:ddSEQ"];

    //     const genesisAccessValue = accessData["custom:Genesis"];

    //     const sequoiaAccessValue = accessData["custom:Sequoia"];

    //     console.log("..............", ddseqAccessValue);

    //     console.log("<<<<<<<<<<<<<<", genesisAccessValue);

    //     console.log(">>>>>>>>>>", sequoiaAccessValue);

    //     sessionStorage.setItem("adminAccessValue", adminAccessValue);

    //     sessionStorage.setItem("ddseqAccessValue", ddseqAccessValue);

    //     sessionStorage.setItem("genesisAccessValue", genesisAccessValue);

    //     sessionStorage.setItem("sequoiaAccessValue", sequoiaAccessValue);

    //     navigate("/products");
    //   })

    //   .catch((error) => {
    //     // Handle errors

    //     console.error(error);
    //   });
  };

  const handleClose = () => {
    setStateMsg({ ...stateMsg, open: false });
  };

  const onSubmit = (event) => {
    // getPrivileges();

    event.preventDefault();

    sessionStorage.clear();

    if (email.trim().length === 0) {
      setIsEmail(true);
    } else {
      setIsEmail(false);
    }

    if (password.trim().length === 0) {
      setIsPassword(true);
    } else {
      setIsPassword(false);
    }

    if (email.trim().length === 0 || password.trim().length === 0) {
      return;
    }

    authenticate(email, password)
      .then((data) => {
        // getPrivileges();
        sessionStorage.setItem("idToken", JSON.stringify(data.idToken));
        sessionStorage.setItem("accessToken", JSON.stringify(data.accessToken));
        handleAccessCheck();

        // navigate("/products")
      })

      .catch((err) => {
        // console.log(err)

        messageBox("error", "Incorrect username or password!");
      });
  };

  return (
    <div>
      <Header isSignUp={true} />

      <div className="bg-img">
        <form onSubmit={onSubmit} className="main-div">
          <div className="margin-bottom-15">
            <h3>Sign In</h3>
          </div>

          <div className="form-group">
            <label>Email</label>

            <input
              type="email"
              className={isEmail ? "form-control is-invalid" : "form-control"}
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              placeholder="Enter Email Address"
            />

            <label for="validationError" class="form-label text-danger">
              {isEmail ? "email is required" : ""}
            </label>
          </div>

          <div className="form-group">
            <label>Password</label>

            <input
              type="password"
              className={
                isPassword ? "form-control is-invalid" : "form-control"
              }
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              placeholder="Enter password"
            />

            <div>
              <label for="validationError" class="form-label text-danger">
                {isPassword ? "password is required" : ""}
              </label>

              <a
                href="#"
                onClick={onForgot}
                className="align-right"
                title="Forgot Password"
                id="link-reset"
              >
                Forgot Password?
              </a>
            </div>
          </div>

          <div class="o-form-button-bar">
            <input
              class="btn btn-primary"
              type="submit"
              value="Sign In"
              id="signin-submit"
              data-type="save"
            />
          </div>
        </form>
      </div>

      {/* <ToastContainer
 
                position="top-center"
 
                autoClose={5000}
 
                hideProgressBar={false}
 
                newestOnTop={false}
 
                closeOnClick
 
                rtl={false}
 
                pauseOnFocusLoss
 
                draggable
 
                pauseOnHover
 
                theme="light"
 
            /> */}

      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={open}
        autoHideDuration={3000}
        onClose={handleClose}
        key={vertical + horizontal}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {msg}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default Login;